/**
 * Font names to use in CSS
 */
export enum FontNames {
  circular = 'Circular',
  circularFallback = 'Circular-fallback',
  circularStd = 'CircularStd',
  signature = 'Signature',
  icons = 'Jerry Mini',
  inter = 'Inter',
  interFallback = 'Inter-fallback',
  lyft = 'Lyft',
}
